<template>
	<div class="projectDetail-container">
		<div class="project-detail-content">
			<div class="timeline">
				<data-table
					:table-data="recordList"
					:column="columns"
					:page-options="pageOptions"
					:border="true"
					:loading="loading"
					@page-change="handlePaginationChange"
				>
					<template slot="permissionDate" slot-scope="scope">
						{{ formatDate(scope.scope.row.permissionDate) }}--{{ scope.scope.row.applyType }}
					</template>
				</data-table>
				<!-- 数据为空 -->
			</div>
		</div>
		<!-- 未开通会员提示 -->
		<nonbind-vip v-if="isVip"></nonbind-vip>
		<!-- 未开通超级会员提示 -->
		<nonbind-svip v-if="isSVip"></nonbind-svip>
	</div>
</template>

<script>
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import NonbindSvip from '@/components/NonBind/nonbindSVip.vue'
	import { getTraceInfo } from '@/api/qualificationQuery/company'
	import DataTable from '@/components/JrTable/DataTable.vue'
	// 企业资质详情信息
	export default {
		name: 'CertSourceDetails',
		components: { NonbindVip, NonbindSvip, DataTable },
		props: {
			companyCode: {
				type: String,
				required: true,
				default: ''
			},
			certCode: {
				type: String,
				required: true,
				default: ''
			}
		},
		data() {
			return {
				// 数据加载状态
				loading: false,
				isVip: false,
				isSVip: false,
				// 记录列表
				recordList: [],
				columns: [
					{ label: '时间', prop: 'permissionDate', align: 'center', slot: 'permissionDate' },
					{ label: '注册专业', prop: 'certInfoName', align: 'center' }
				],
				// 分页配置
				pageOptions: {
					page: 1,
					limit: 10,
					total: 0
				}
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.initDetail()
		},
		methods: {
			// 格式化日期
			formatDate(dateStr) {
				if (dateStr) {
					return dateStr.split(' ')[0]
				}
				return ''
			},
			initDetail() {
				this.loading = true
				const params = {
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					companyCode: this.companyCode,
					certCode: this.certCode
				}
				getTraceInfo(params)
					.then(res => {
						const { data, code, message } = res
						if (code === 6102) {
							this.isVip = true
						} else if (code === 6104) {
							// 当前是svip 权益已经使用完，提示次数已经用完了，请等待会员权益重置再使用
							this.$message.warning(message)
						} else if (code === 6105) {
							// 当前是vip 权益已经使用完，提示次数已经用完了，请用户升级为svip
							this.isSVip = true
						} else {
							if (data) {
								this.recordList = data
							}
						}
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},
			// 分页
			handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.initDetail()
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/timeline.scss';
</style>
